import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    MERGE_APM_CONFIG: null,
    CLEAR_APM_CONFIG: null
});
export const REDUCER_NAME = 'apm';
